import { render } from "./TvmSlideOutBbTradeValue.vue?vue&type=template&id=3e998a5b&scoped=true"
import script from "./TvmSlideOutBbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutBbTradeValue.vue?vue&type=script&lang=js"

import "./TvmSlideOutBbTradeValue.vue?vue&type=style&index=0&id=3e998a5b&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e998a5b"]])

export default __exports__